module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/132-bosnia-and-herzegovina-81b8ea48d0a4f713b0a88ced760cdca0.svg";